<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {activeProducts} from '@/utils/authorization-info-utils'

    @Component
    export class AuthInfoMixin extends Vue {
        get activeProducts() {
            const productList = [
                'hotels',
                'flights',
                'activities',
                'transfers',
                'carsRent',
                'tour',
                'cruises',
                'visa',
                'insurance',
                'extraServices',
                'packages',
                'tours',
                'conferenceHall',
                'catering',
            ]
            const products = this.$conf.public.activeProducts.filter(product => productList.includes(product))
            return activeProducts(products, authStore.availableProducts)
        }

        get shortListActiveProducts() {
            const productList = [
                'hotels',
                'flights',
                'activities',
                'transfers',
                'carsRent',
                'tour',
                'cruises',
                'visa',
                'insurance',
                'extraServices',
                'tours',
            ]
            const products = this.$conf.public.activeProducts.filter(product => productList.includes(product))
            return activeProducts(products, authStore.availableProducts)
        }
    }

    export default AuthInfoMixin
</script>
